export const branchExtraCommission = (branchObj) => {
  const value = Number(branchObj && branchObj.extra_commission);
  return Number.isFinite(value) ? value : 0;
};

export const withNumericCommission = (variant) => {
  const value = Number(variant && variant.commission_rate);
  return { ...variant, commission_rate: Number.isFinite(value) ? value : 0 };
};
